export enum partPaymentType {
  NO_OF_INSTALLMENT = 'NoOfInstallment',
  INSTALLMENT_AMOUNT = 'InstallmentAmount',
}

export enum PartPaymentBMD {
  MINIMUM = "Minimum",
  MAX_NO_OF_INSTALMENT = "MaxNoOfInstallment",
  MIN_INSTALLMENTS_FOR_COST = "MinInstallmentsForCost",
  MIN_REMAINING_BALANCE_FOR_COST = "MinRemainingBalanceForCost",
  FORWARD_CHARGE = "ForwardCharge",
  TERM_CHARGE = "TermCharge"
}

export enum PartPaymentFeeType {
  FORWARD_CHARGE = "forwardCharge",
  COSTS = "costs"
}

export enum InstallmentIntervals {
  WEEK = 'Week',
  BIWEEKLY = 'Biweek',
  MONTH ='Month',
  QUARTER='Quarter',
  YEAR='Year',
}

export enum PartPaymentGenerateType {
  AMOUNT = "amount",
  INSTALLMENT = "installment",
}

export enum PartPaymentcomunicationMethod {
  SMS = "sms",
  EMAIL = "email",
}
